module.exports = __webpack_public_path__ + "static/media/card_red.825f591f.svg";